import {
  ScreeningSetup,
  ScreeningSetupResponse,
  ScreeningSetupUpdate,
} from '../types/screening';

import { IScreeningRepository } from './interfaces/IScreeningRepository';

// Mock data for development - in production, this would come from an API
const MOCK_SCREENING_SETUPS: ScreeningSetup[] = [
  {
    id: '1',
    listingId: '1',
    isSetup: true,
    applicationLink: 'https://apply.link/23xyz',
    createdAt: new Date('2024-01-10T10:00:00Z'),
    updatedAt: new Date('2024-01-10T10:00:00Z'),
  },
  {
    id: '2',
    listingId: '2',
    isSetup: false,
    applicationLink: 'https://apply.link/23xyz',
    createdAt: new Date('2024-01-10T10:00:00Z'),
    updatedAt: new Date('2024-01-10T10:00:00Z'),
  },
];

export class ScreeningRepository implements IScreeningRepository {
  private screeningSetups: ScreeningSetup[] = MOCK_SCREENING_SETUPS;

  async getScreeningSetup(listingId: string): Promise<ScreeningSetupResponse> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 100));

    const screeningSetup = this.screeningSetups.find(
      setup => setup.listingId === listingId
    );

    return {
      screeningSetup: screeningSetup || null,
    };
  }

  async createScreeningSetup(
    listingId: string,
    applicationLink: string
  ): Promise<ScreeningSetup> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 200));

    const newScreeningSetup: ScreeningSetup = {
      id: Date.now().toString(),
      listingId,
      isSetup: true,
      applicationLink,
      createdAt: new Date(),
      updatedAt: new Date(),
    };

    this.screeningSetups.push(newScreeningSetup);
    return newScreeningSetup;
  }

  async updateScreeningSetup(
    id: string,
    updates: ScreeningSetupUpdate
  ): Promise<ScreeningSetup> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 200));

    const index = this.screeningSetups.findIndex(setup => setup.id === id);
    if (index === -1) {
      throw new Error('Screening setup not found');
    }

    const current = this.screeningSetups[index];
    if (!current) {
      throw new Error('Screening setup not found');
    }

    const updatedSetup: ScreeningSetup = {
      id: current.id,
      listingId: current.listingId,
      isSetup:
        updates.isSetup !== undefined ? updates.isSetup : current.isSetup,
      createdAt: current.createdAt,
      updatedAt: new Date(),
    };

    // Handle optional applicationLink property
    if (updates.applicationLink !== undefined) {
      updatedSetup.applicationLink = updates.applicationLink;
    } else if (current.applicationLink !== undefined) {
      updatedSetup.applicationLink = current.applicationLink;
    }

    this.screeningSetups[index] = updatedSetup;
    return updatedSetup;
  }
}

// Singleton instance
export const screeningRepository = new ScreeningRepository();
